'use strict';

const timeago = require('timeago.js');
const fr = require('timeago.js/locales/fr.js');
const es = require('timeago.js/locales/es.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:timeago');
// Locales are registered as language tags for convenience as siteConfig.locale
// is a language tag. Timeago uses an exact match, no fallback to first part of
// the tag.
//
// See:
//   - htdocs/locale/
//   - http://www.rfc-editor.org/rfc/rfc5646.txt
timeago.register('fr', fr);
timeago.register('fr-ca', fr);
timeago.register('es', es);
timeago.register('es-419', es);

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    // Enable the relative date for recent dates.
    // One day (in milliseconds).
    // See server side "isTimeagoRecent" in web/context.js where this value is
    // duplicated.
    const RecentThreshold = 86400 * 1000;

    // Refresh the relative date every one minute (in milliseconds);
    const RefreshDelay = 60 * 1000;

    /**
     * PhoenixTimeago
     *
     * Wrapper around the timeago.js library used to display relative dates.
     *
     * 1) SEO friendly: This custom element is designed to be used in conjuction
     *    with <time>. Reading the timestamp from <time> "datetime" attribute.
     *    (reading the timestamp from <time> text content is not supported)
     *    (only the first <time> element of the subtree is processed)
     *
     * 2) Localization: A few locales are registered, matching the locales
     *    defined in htdocs/locale/
     *
     * 3) Settings: The reference date is "now" as computed on the client, and
     *    relative dates are displayed only if the difference is less than 24 hours.
     *
     * @example
     *   <phoenix-timeago locale="en">
     *     <time datetime="2018-06-30T00:00:00-08:00">Jun 30, 2018</time>
     *   </phoenix-timeago>
     */
    class PhoenixTimeago extends pageClass.PhoenixElement {
        connectedCallback() {
            this.locale = this.getAttr('locale') || 'en';
            this.renderRelative = !this.hasAttribute('render-absolute');
            this.waitForElement('time', { untilDomReady: true }).then((timeElement) => {
                const datetime = timeElement.getAttribute('datetime');
                if (!datetime) {
                    throw new Error('missing time datetime attribute');
                }
                const date = new Date(datetime);
                const now = new Date();
                if (date.getTime() < now.getTime() - RecentThreshold) {
                    return;
                }
                this._date = date;
                this._timeElement = timeElement;

                // update immediately
                this.updateTime();

                // then update every minute
                if (this.renderRelative) {
                    this._interval = setInterval(() => {
                        this.updateTime();
                    }, RefreshDelay);
                }
            });
        }

        updateTime() {
            if (this.renderRelative && this._timeElement && this._date) {
                this._timeElement.textContent = timeago().format(this._date, this.locale);
            }
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            if (this._interval) {
                clearInterval(this._interval);
            }
        }
    }
    window.customElements.define('phoenix-timeago', PhoenixTimeago);
    measure.end();
});
